import Interaction from "../../../models/interactions/Interaction";
import { IMath } from "../../../models/interactions/Math";
import useUpdateSequenceInteraction from "./UpdateSequenceInteraction.hook";
import VariableSelector from "../variables/VariableSelector";
import TypedMatchInput from "../components/TypedMatchInput";
import { VariableType } from "../../../models/interactions/Variable";
import { useSelector } from "react-redux";
import { selectSequenceVariables } from "../../../app/slices/TrainingSlice";

export default function MathNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  const mathNode = props.interaction as IMath;
  const { updateInteraction } = useUpdateSequenceInteraction();
  const variables = useSelector(selectSequenceVariables);

  return (
    <div className="w-full h-full flex flex-col gap-[12px]">
      <TypedMatchInput
        label="Input"
        value={String(mathNode.input)}
        onChange={(val) => {
          const isVarRef = variables.some((v) => v.id === val);
          updateInteraction(props.nodeId, {
            ...mathNode,
            input: isVarRef || isNaN(Number(val)) ? val : Number(val),
          } as IMath);
        }}
        variableType={VariableType.Number}
        variables={variables}
      />
      <TypedMatchInput
        label="Amount"
        value={String(mathNode.amount)}
        onChange={(val) => {
          const isVarRef = variables.some((v) => v.id === val);
          updateInteraction(props.nodeId, {
            ...mathNode,
            amount: isVarRef || isNaN(Number(val)) ? val : Number(val),
          } as IMath);
        }}
        variableType={VariableType.Number}
        variables={variables}
      />
      <VariableSelector
        variables={variables}
        selectedVariableId={mathNode.output}
        label="Output Variable"
        filterByType={VariableType.Number}
        includeBuiltIns={false}
        onSelect={(variableId) =>
          updateInteraction(props.nodeId, {
            ...mathNode,
            output: variableId,
          } as IMath)
        }
      />
    </div>
  );
}
